import clsx from "clsx";
import {
  Facebook,
  FileText,
  Instagram,
  LogIn,
  Shield,
  Twitter,
  Youtube,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import { FaInstagram, FaTiktok, FaYoutube } from "react-icons/fa";
import { SiX } from "react-icons/si";
import { Link } from "react-router-dom";
import { LinkPreview } from "../../utils/aceternity/LinkPreview";
import { PATHS } from "src/routes/Paths";
import CustomCollapse from "../common/CustomCollapse";

export default function Footer() {
  const { t } = useTranslation();

  const socialLinks = [
    { icon: FaTiktok, href: "https://www.tiktok.com/@saffwfd", name: "TikTok" },
    { icon: SiX, href: "https://x.com/Saudi_WPL", name: "Twitter" },
    {
      icon: Instagram,
      href: "https://www.instagram.com/saudi_wpl/?hl=en",
      name: "Instagram",
    },
    {
      icon: Youtube,
      href: "https://www.youtube.com/@Saudi_WPL",
      name: "Youtube",
    },
  ];

  const footerLinks = [
    {
      title: t("QuickLinks"),
      links: [
        { label: t("SAFF"), href: "https://saff.com.sa" },
        // { label: t("MinistryOfSports"), href: "https://www.mos.gov.sa/" },
      ],
    },
  ];

  return (
    <footer
      className={clsx(
        "relative text-white py-20 overflow-hidden mt-10",
        "bg-gradient-to-r from-success to-success/95"
      )}
    >
      {/* <img
        src={footer_graphic}
        className="absolute inset-0 w-full h-full object-cover object-left z-0"
      /> */}

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Section */}
          <div className="space-y-6">
            <h2 className="text-2xl font-bold"> {t("SAFFCLOUD")} </h2>
            <p className="text-gray-300">{t("OfficialPlatformDescription")}</p>
            {/* <div className="flex items-center gap-4 max-sm:justify-between">
              {socialLinks.map(({ icon: Icon, href, name }) => (
                <motion.a
                  key={name}
                  href={href}
                  target="_blank"
                  whileHover={{ scale: 1.1 }}
                  className="p-2 rounded-full hover:bg-white/10"
                  aria-label={name}
                >
                  <Icon className="w-5 h-5 max-sm:w-8 max-sm:h-8" />
                </motion.a>
              ))}
            </div> */}

            {/* <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              // onClick={() => navigate("/signin")}
              onClick={() => navigate(`${PATHS.signin}`)}
              className="flex items-center gap-2 px-6 py-3 bg-[#02B510] hover:bg-[#02F119] rounded-full text-white font-medium transition-colors"
            >
              <LogIn className="w-5 h-5" />
              {t("auth.signInButton")}
            </motion.button> */}
          </div>

          {/* Footer Links */}
          {footerLinks.map((section) => (
            <div className="max-sm:hidden" key={section.title}>
              <h3 className="font-semibold mb-4">{section.title}</h3>
              <ul className="space-y-3">
                {section.links.map((link) => (
                  <li key={`${section.title}-${link.label}-${link.href}`}>
                    <a
                      href={`${link.href}`}
                      target="_blank"
                      className="text-gray-300 hover:text-white"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="hidden max-sm:block">
            <CustomCollapse items={footerLinks} />
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-16 pt-8 border-t border-white/10 text-center text-gray-300">
          <div className="flex gap-1 text-base text-center justify-center items-center max-sm:flex-col">
            <div className="max-sm:w-full">
              {" "}
              © {new Date().getFullYear()} {t("footerText")}
            </div>
            <LinkPreview url="https://saff.com.sa" className="">
              <span className="text-primary font-bold">
                {t("footerTextPart2")}
              </span>
            </LinkPreview>
          </div>

          <div className="mt-2 flex justify-center gap-6 max-sm:text-xs items-center text-sm max-sm:mt-5">
            <Link
              to={PATHS.privacy_policy}
              className="flex items-center gap-2 text-gray-300 hover:text-white"
            >
              <Shield className="w-4 h-4" />
              {t("PrivacyPolicy")}
            </Link>
            <Link
              to={PATHS.terms_and_condition}
              className="flex items-center gap-2 text-gray-300 hover:text-white"
            >
              <FileText className="w-4 h-4" />
              {t("TermsAndConditions")}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}